export const DEFAULT_INVOICE_SORT = 'invoiceDate:desc';

/**
 * Append a stable secondary `_id` tiebreaker so server-side pagination stays
 * deterministic (rows with identical primary-sort values keep a fixed order
 * across pages). No-op when the caller already sorts by `_id`.
 */
export const ensureStableSort = (
  value?: string,
  fallback: string = DEFAULT_INVOICE_SORT,
) => {
  const base = value ?? fallback;

  return base.includes('_id:') ? base : `${base},_id:desc`;
};
